import * as questions from "./questions";

export const center = {
    ...questions,
}